import React from 'react';
import { IconBase } from '../Base';
export const IconChevronUpDown = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("g", { style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
            React.createElement("path", { d: "M7.08301 11.875L9.99967 14.7917L12.9163 11.875" }),
            React.createElement("path", { d: "M7.08301 8.125L9.99967 5.20833L12.9163 8.125" }))));
};
//# sourceMappingURL=UpDown.js.map